import styles from './ImageTopBar.module.css';

const ImageTopBar = ({ children }) => {
  return <div className={styles.bar}>{children}</div>;
};

export default ImageTopBar;
